import { useCallback } from "react";
import { useQuery } from "./useQuery";
import { MOCK_CASH_FLOW } from "../pages/Accounting/Overview/overviewMockData";
import type {
  CashFlowPoint,
  OverviewPeriod,
} from "../pages/Accounting/Overview/overviewTypes";
import type { QueryResult } from "./types";

/**
 * Cash flow (money in vs money out) per month.
 * Default: populated. ?populated=0 flips to empty.
 */
export function useCashFlow(_period: OverviewPeriod = "this_year"): QueryResult<CashFlowPoint[]> {
  const query = useQuery();
  const populated = query.get("populated") !== "0";
  const data: CashFlowPoint[] = populated ? MOCK_CASH_FLOW : [];

  const refetch = useCallback(() => {}, []);
  return { data, loading: false, error: null, refetch };
}